// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73e9c9d3","453":"9e346371","851":"71ac19c7","977":"98d7eb14"}[chunkId] + ".chunk.js";
};